import { render, staticRenderFns } from "./grpe.vue?vue&type=template&id=6b5f85a7"
import script from "./grpe.vue?vue&type=script&lang=js"
export * from "./grpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports